// Google Reviews content for the home-page Reviews section.
//
// i18n-todo: backend content — review name/date/text are real user-generated
// content (spec non-goal); not translated. Only the section chrome is localized.
//
// PLACEHOLDER DATA — Google blocks automated scraping of the reviews dialog, so
// these are stand-ins for layout. Replace `googleReviews` with the real reviews
// (copy name / rating / relative date / text from the business's Google
// listing) and update `reviewsSummary` to match the live average + count. The
// section markup reads only the fields below, so editing here is all you need.
//
// Review fields:
//   name   – reviewer display name
//   avatar – path to an avatar image, or null to auto-generate initials
//   rating – integer 1–5 (renders that many filled stars)
//   date   – relative string exactly as Google shows it ("2 weeks ago")
//   text   – the review body

export const reviewsSummary = {
  rating: 4.9,
  count: 27,
  // The business listing reviews URL — "Read all reviews on Google" links here.
  url: "https://www.google.com/search?q=celestial+code#lrd=0x311d639376e9c553:0x7f5cc1c8480e0590,1",
};

export const googleReviews = [
  {
    name: "Mongkon Utamakaew",
    avatar: null,
    rating: 5,
    date: "a month ago",
    text: "Celestial Code delivers highly customized web and application solutions tailored to each client’s needs. The team is responsive, detail-oriented, and capable of turning complex requirements into practical, well-designed systems. Strong communication and reliable delivery make them a solid partner for businesses looking for scalable digital solutions.",
  },
  {
    name: "402_15_น.ส.พิมลสิริ อุตะมะแก้ว",
    avatar: null,
    rating: 5,
    date: "a month ago",
    text: "Working with Celestial Code has been a smooth and professional experience. They take the time to understand business requirements and translate them into effective digital solutions. The team is reliable, flexible, and delivers quality work that aligns well with client expectations. A great choice for custom website and application development.",
  },
  {
    name: "Thananan Group",
    avatar: null,
    rating: 5,
    date: "a year ago",
    text: "Celestial Code offers top-notch custom software development services. Their team is professional, efficient, and dedicated to providing tailored solutions. Highly recommended!",
  },
  {
    name: "voradej panjarongkha",
    avatar: null,
    rating: 5,
    date: "a year ago",
    text: "Celestial Code is a reliable software development company that delivers high-quality custom websites and applications. Their team is responsive, professional, and always goes above and beyond to meet client needs. Highly recommend for businesses looking for tailored tech solutions.",
  },
  {
    name: "Lertphiphat Linkaow",
    avatar: null,
    rating: 4,
    date: "a year ago",
    text: "Smart solutions from a reliable Thai software house.",
  },
  {
    name: "Juthamas",
    avatar: null,
    rating: 5,
    date: "a year ago",
    text: "Tailor-made reults,ringht on point.",
  },
  {
    name: "ทิพย์ธิดา มะลิวัลย์",
    avatar: null,
    rating: 5,
    date: "a year ago",
    text: "Highly professional and responsive team",
  },
  {
    name: "Narisa Yusoh",
    avatar: null,
    rating: 5,
    date: "4 months ago",
    text: "",
  },
];
